import { useEffect, useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "../../api/client";
import Card from "../../components/ui/Card";
import Input from "../../components/ui/Input";
import Button from "../../components/ui/Button";
import Select from "../../components/ui/Select";

const STEPS = ["Contact Info","Reset password"];

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  const [step, setStep] = useState(0);
  const [form, setForm] = useState({ otp:"", phone:"", password:"", confirmPw:"" });
  const [err,  setErr]  = useState("");
  const [errphone, setPhoneError] = useState("");
  const [selectedType, setSelectedType] = useState('email');
  const [otp, setOTP] = useState("");
  
  const [timeLeft, setTimeLeft] = useState(0);
  const [clickCount, setClickCount] = useState(0);
  const timerRef = useRef<number | null>(null);

  const startTimer = async () => {
    const phoneRegex = /^\+?[0-9\s\-()]{7,15}$/;

    if(!phoneRegex.test(form.phone)){
      setPhoneError("Invalid phone number. (eg. 080 0000 0000)");
      return;
    }
    const cleanedPhone = form.phone.replace(/(?!^\+)\D/g, "");

    if (timeLeft > 0) return; // Prevent double clicks if already running
    setClickCount(1);
    setTimeLeft(120); // Set countdown duration (e.g., 30 seconds)
    await api.post("/sendOTP/send", {phone:cleanedPhone}) as any;
  };

  useEffect(() => {
    // If timeLeft is greater than 0, set up a 1-second interval ticker
    if (timeLeft > 0) {
      timerRef.current = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    } else if (timeLeft === 0 && timerRef.current) {
      // Clear interval when time runs out
      clearInterval(timerRef.current);
    }

    // Crucial: Clean up the interval if the user navigates away or closes the component
    return () => clearInterval(timerRef.current || undefined);
  }, [timeLeft]);

  const set = (k: string) => (v: string) => setForm(f => ({ ...f, [k]:v }));

  const next = async () => {
    if (step < 1) {
      if (step === 0){
        setStep(s => s+1);
      }
      return;
    }
    
    try {
      const cleanedPhone = form.phone.replace(/(?!^\+)\D/g, "");
      const response = await api.post("/sendOTP/reset", {
        otp: otp, phone: cleanedPhone, password: form.password,
      }) as any;
      if (response.Error === "None"){
        alert('Your password reset was successful.');
        navigate("/login");
      }
      else{
        alert('There was an issue with password reset!');
      }
    } 
    catch(e: any) 
    { setErr(e?.error || "Error resetting password"); }
  };

  const handleChange = () =>{setStep(s => (s-1));};

  const handleRadioChange = (event: any) => {setSelectedType(event.target.value);};

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900 p-5">
      <div className="w-full max-w-md">
        <div className="flex gap-1.5 mb-5">
          {STEPS.map((_, i) => (
            <div key={i} className="flex-1 h-1 rounded-full transition-all duration-300"
              style={{ background: i <= step ? "#059669" : "#475569" }}/>
          ))}
        </div>        
        <Card>
          <h2 className="text-base font-medium text-slate-700 mb-5">{STEPS[step]}</h2>
          {err && <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700">{err}</div>}
          {step===0 && <>
            <Input label="Phone number" type="tel" value={form.phone} onChange={set("phone")} error={errphone} />
            <label className="text-center text-sm text-slate-500 mt-3" style={{marginRight:"20px"}}><input type="radio" name="messageType" value="email" checked={selectedType === 'email'} onChange={handleRadioChange} />Send via Email</label>
            <label className="text-center text-sm text-slate-500 mt-3" style={{marginRight:"20px"}}><input type="radio" name="messageType" value="phone" checked={selectedType === 'phone'} onChange={handleRadioChange} />Send as SMS</label>
            {/* <Button onClick={handleChange} size="sm" className="center clearance btn_bkgrd">Send OTP</Button> */}

            <button 
              onClick={startTimer}
              className="center clearance btn_bkgrd"
              disabled={timeLeft > 0} // Disables the button while countdown is active
              style={{
                padding: '5px 10px',
                cursor: timeLeft > 0 ? 'not-allowed' : 'pointer',
                backgroundColor: timeLeft > 0 ? '#cccccc' : '#007bff',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                marginBottom: '5px'
              }}
            >
              {clickCount < 1? "Send OTP" : timeLeft > 0 ? `Resend OTP in ${timeLeft}s` : 'Resend OTP'}
            </button>

            {clickCount<1? "" : 
              <div style={{width:"40%", marginBottom:"10px", marginTop:"5px"}}>
                <p>Enter OTP</p>
                <input type="numeric" onChange={(e)=>setOTP(e.target.value)} placeholder="_ _ _ _ _ _" maxLength={6} required className="w-full px-3 py-2.5 border rounded-lg text-lg text-slate-800 outline-none bg-white" />
              </div>
            }
          </>}
          {step===1 && <>
            <Input label="Password" type="password" value={form.password}   onChange={set("password")}   placeholder="Min 8 characters"/>
            <Input label="Confirm password" type="password" value={form.confirmPw} onChange={set("confirmPw")}
              error={form.confirmPw && form.password !== form.confirmPw ? "Passwords don't match" : null}/>              
          </>}
          {otp.length<6? "" : 
            <Button onClick={next} size="lg" className="w-full justify-center">
              {step < 1 ? "Continue →" : "Reset Password"}
            </Button>
          }
          <p className="text-center text-sm text-slate-500 mt-3">
            Go to login page? <Link to="/login" className="text-emerald-600 font-medium">Sign in</Link>
          </p>
        </Card>
      </div>
    </div>
  );
}